<div class="container">
  <div class="row align-items-center mt-5 mb-5">
    <div class="col-sm-4"></div>
    <div class="btn btn-danger col-sm-4" (click)="add()">Create Course</div>
    <div class="col-sm-4"></div>
  </div>
</div>
